import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
	AuthActionTypes,
	AuthGenericError,
	CheckPasswordError,
	SigninErrorInfo,
	ToastrAyService,
	ToastrType,
} from "features";
import { tap } from "rxjs/operators";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";

@Injectable()
export class AuthAyEffect {
	constructor(
		private actions$: Actions,
		private toastrAy: ToastrAyService,
	) {}

	signinErrorInfo$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType<SigninErrorInfo>(AuthActionTypes.SigninErrorInfo),
				tap(({ payload }) => {
					this.toastrAy.showToastr({
						message: payload,
						type: ToastrType.ERROR,
					});
				}),
				catchError((err) => {
					return of(new AuthGenericError());
				}),
			),
		{ dispatch: false },
	);

	checkPasswordError$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType<CheckPasswordError>(AuthActionTypes.CheckPasswordError),
				tap(({ payload }) => {
					this.toastrAy.showToastr({
						message: "payload",
						type: ToastrType.ERROR,
					});
					return false;
				}),
				catchError((err) => {
					return of(new AuthGenericError());
				}),
			),
		{ dispatch: false },
	);
}
